import { h } from "preact";
import { useAssetLoader } from "../../../hooks/asset-loader";
import { useClientConfigurations } from "../../../hooks/client-configurations";
import { useExternalActionHandler } from "../../../hooks/external-action-handler";
import { useRouterActionHandler } from "../../../hooks/router";
import { IActionHandler } from "../../../interfaces/event-actions";
import { IFragment } from "../../../interfaces/fragment";
import { IStatus } from "../../../interfaces/status";
import { Info } from "../../info";
import ErrorRoot1, {
  IMainErrorRoot1Layouts,
} from "../../routes/main-error-root-1";

export function ErrorWrapper({
  status,
  onAction,
}: {
  status: IStatus;
  onAction?: IActionHandler;
}) {
  const [state, dispatch] = useClientConfigurations();
  const [onRouterAction] = useRouterActionHandler();
  const [onExternalAction] = useExternalActionHandler();

  useAssetLoader(state?.error?.mainError);


  const onCurrentAction: IActionHandler = (action, details) => {
    if (onAction) onAction(action, details);
    else {
      onRouterAction(action, details);
      onExternalAction(action, details);
    }
  };

  try {
    const selectedFragment = state.error.mainError;
    const root = selectedFragment.byId[selectedFragment.rootId];
    if (root.type_id === "ERROR_ROOT_1") {
      return (
        <ErrorRoot1
          status={status}
          screen={selectedFragment as IFragment<IMainErrorRoot1Layouts>}
          onAction={onCurrentAction}
          {...root}
        />
      );
    }
  } catch (e) {
    return <Info status={status} />;
  }
}
